import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { api } from "@/lib/api";
import InstagramPostMaker from "@/pages/InstagramPostMaker";
import InstagramPostMakerV2 from "@/pages/InstagramPostMakerV2";
import InstagramPostMakerV3 from "@/pages/InstagramPostMakerV3";
import InstagramPostMakerV5 from "@/pages/InstagramPostMakerV5";

// Users always land on /instagram-post-maker and never see version numbers.
// Which implementation renders is decided by the admin-controlled active version.
// Admins can force a version for preview via ?v=1 / ?v=2 / ?v=3 without changing the live setting.
export default function InstagramEntry() {
  const [params] = useSearchParams();
  const [cfg, setCfg] = useState(null);
  useEffect(() => { api.igConfig().then(setCfg).catch(() => setCfg({ active_version: "v1", v2_enabled: false, v3_enabled: false, is_admin: false })); }, []);

  if (!cfg) return <div className="flex min-h-screen items-center justify-center bg-[#0A0A0A]"><Loader2 className="animate-spin text-[#E1306C]" /></div>;

  const forced = params.get("v");
  const isAdmin = !!cfg.is_admin;

  // Admin preview override.
  if (forced === "5" && isAdmin) return <InstagramPostMakerV5 />;
  if (forced === "4" && isAdmin) return <InstagramPostMakerV3 preview v4Mode />;
  if (forced === "3" && isAdmin) return <InstagramPostMakerV3 preview />;
  if (forced === "2" && isAdmin) return <InstagramPostMakerV2 preview />;
  if (forced === "1" && isAdmin) return <InstagramPostMaker />;

  // Live selection: a version renders only when it's both active AND enabled.
  // V4 = Google image-input engine, delivered through the V3 UI with "keep my photo" on.
  if (cfg.active_version === "v5" && cfg.v5_enabled) return <InstagramPostMakerV5 />;
  if (cfg.active_version === "v4" && cfg.v4_enabled) return <InstagramPostMakerV3 v4Mode />;
  if (cfg.active_version === "v3" && cfg.v3_enabled) return <InstagramPostMakerV3 />;
  if (cfg.active_version === "v2" && cfg.v2_enabled) return <InstagramPostMakerV2 />;
  return <InstagramPostMaker />;
}
